import {createVuetify, type ThemeDefinition} from 'vuetify'
import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/dist/vuetify-labs.css'
import 'vuetify/styles'

const xigaTheme: ThemeDefinition = {
    dark: false,
    colors: {
        'contrast': '#121212',
        background: '#F5F5F5',
        surface: '#FFFFFF',
        'ghost-white': '#F7F6F1',

        'gray-light': '#F9F9F9',

        'gray-dark': '#E4E4E4',

        primary: '#2e3192',
        'primary-light': '#5a5fb3',
        'primary-accent': '#1a1d66',

        secondary: '#37A055',
        'secondary-light': '#5cbf77',
        'secondary-accent': '#1f6030',

        tertiary: '#00AA08',
        'tertiary-light': '#A3DCA0',

        error: '#B00020',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#FB8C00',
        'disabled-light': '#F7F6F1',
        'disabled-dark': '#CACACA',
    },
    variables: {
        'logo-url': 'url(/images/logo.webp)',
        'hero-image-url': 'url(/images/hero.jpg)',
        'card-background-url': 'url(/images/misc/blue-background.png)',
    },
}


const xigaDarkTheme: ThemeDefinition = {
    dark: true,
    colors: {
        contrast: '#F5F5F5',
        background: '#121212',
        surface: '#1E1E1E',
        'ghost-white': '#2C2C2C',

        'gray-light': '#3A3A3A',

        'gray-dark': '#1F1F1F',

        primary: '#2e3192',
        'primary-light': '#5A5FB3',
        'primary-accent': '#2E3192',

        secondary: '#5CBF77',
        'secondary-light': '#81D29A',
        'secondary-accent': '#37A055',

        tertiary: '#A3DCA0',
        'tertiary-light': '#C6EEC2',

        error: '#CF6679',
        info: '#64B5F6',
        success: '#81C784',
        warning: '#FFB74D',
        'disabled-light': '#3A3A3A',
        'disabled-dark': '#797979',
    },
    variables: {
        'logo-url': 'url(/images/logo-white.webp)',
        'hero-image-url': 'url(/images/hero.jpg)',
        'card-background-url': 'url(/images/misc/blue-background.png)',
    },
};


export default defineNuxtPlugin((app) => {
    const vuetify = createVuetify({
        theme: {
            defaultTheme: 'xigaTheme',
            themes: {
                xigaTheme,
                xigaDarkTheme,
            },
        },
        ssr: true,
    })
    app.vueApp.use(vuetify)
})
